import React from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { Home, CheckSquare, Brain, CalendarDays, Search, Settings } from "lucide-react"

function cn(...classes) {
  return classes.filter(Boolean).join(" ")
}

const mobileNavItems = [
  { icon: Home, label: "Home", path: "/dashboard" },
  { icon: CheckSquare, label: "Tasks", path: "/tasks" },
  { icon: Brain, label: "Study", path: "/study-assistant" },
  { icon: CalendarDays, label: "Attend", path: "/attendance" },
  { icon: Search, label: "Lost", path: "/lost-found" },
  { icon: Settings, label: "Settings", path: "/settings" },
]

export function MobileBottomNav() {
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <nav className={cn(
      "fixed bottom-0 left-0 right-0 z-50 flex sm:hidden items-center justify-around",
      "px-2 pt-2 pb-safe pb-3 border-t",
      "bg-white/90 dark:bg-black/90 backdrop-blur-xl border-gray-200/80 dark:border-white/8"
    )}>
      {mobileNavItems.map((item) => {
        const Icon = item.icon
        const isActive = location.pathname === item.path || location.pathname.startsWith(item.path + "/")
        // Special case: /study-assistant sub-routes should keep Study active
        const isStudyActive = item.path === "/study-assistant" && location.pathname.startsWith("/study-assistant")

        return (
          <button
            key={item.label}
            onClick={() => navigate(item.path)}
            className="flex flex-col items-center gap-0.5 px-2 py-1 min-w-0 group"
          >
            <span className={cn(
              "w-10 h-10 flex items-center justify-center rounded-2xl transition-all duration-200",
              isActive
                ? "bg-gray-900 dark:bg-white text-white dark:text-black shadow-lg scale-105"
                : "text-gray-400 dark:text-gray-500 group-hover:text-gray-700 dark:group-hover:text-gray-300"
            )}>
              <Icon className="h-5 w-5" />
            </span>
            <span className={cn(
              "text-[9px] font-bold leading-none transition-all",
              isActive
                ? "text-gray-900 dark:text-white"
                : "text-gray-400 dark:text-gray-500"
            )}>
              {item.label}
            </span>
          </button>
        )
      })}
    </nav>
  )
}
